import React from "react";
import {
  Button,
  Col,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  Row,
} from "reactstrap";
import ModalHeader from "@dhn/components/molecules/modal-header";

export default function ModalTabServicesAddResult({
  isOpen,
  dataNecesaryModal,
  onChange,
  onChangeTabServices,
  isPageModalHistory,
}) {
  let valueResult;
  return (
    <div>
      <Modal isOpen={isOpen} size="lg" centered>
        <ModalHeader
          toggle={() => onChange("tabServices", false, "isOpenModal")}
          iconClass="fa-stethoscope"
          description="Resultado de servicio"
          subtitle="Complete las observaciones del análisis del servicio."
        />
        <ModalBody>
          <Row form>
            <Col className="d-flex flex-column">
              <Label>Observaciones del Análisis:</Label>
              <Input
                type="textarea"
                disabled={isPageModalHistory}
                defaultValue={dataNecesaryModal?.result}
                onChange={({ target: { value } }) => (valueResult = value)}
              />
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button
            disabled={isPageModalHistory}
            color="success"
            className="btn-color-success"
            onClick={() => {
              onChangeTabServices(
                "result",
                valueResult,
                dataNecesaryModal?.serviceId
              );
              onChange("tabServices", false, "isOpenModal");
            }}
          >
            <i className="fa fa-plus"></i>
            {" Agregar"}
          </Button>
          <Button
            color="danger"
            className="btn-color-danger"
            onClick={() => {
              onChange("tabServices", false, "isOpenModal");
            }}
          >
            <i className="fa fa-times"></i>
            {" Cancelar"}
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
}
